import { defineStore } from 'pinia'
import { RouteLocationNormalizedLoadedGeneric } from 'vue-router'

import { IMenuItem } from '@/types/menu.type'
import { MenuItem } from '@/types/settings.type'
import { transformPath } from '@/utils/transformer'

export const useMenuStore = defineStore('MenuStore', {
  state: () => {
    return {
      items: [] as IMenuItem[],
      activeItem: null as IMenuItem | null
    }
  },
  getters: {
    getItems: (state): IMenuItem[] => {
      return state.items
    },

    getActiveItem: (state): IMenuItem | null => {
      return state.activeItem
    }
  },
  actions: {
    setItems (items: IMenuItem[]) {
      this.resetActiveItem()

      this.items = items || []
    },

    prepareItems (items: MenuItem[] | null | undefined, parent?: IMenuItem): IMenuItem[] {
      return [...(items || [])]
        .sort((first, second) => first.Weight - second.Weight)
        .map(item => {
          const url = transformPath(item.URL)
          const currentItem: IMenuItem = {
            id: item.Uuid,
            active: false,
            icon: item.MIcon,
            vIcon: item.VIcon,
            title: item.T,
            url,
            ...(parent ? { parent } : {}),
            children: []
          }

          if (item.Items) {
            currentItem.children = this.prepareItems(item.Items, currentItem)
          }

          // Если у элемента нет URL, устанавливаем URL первого потомка
          currentItem.url = currentItem.url || currentItem.children[0]?.url || ''
          return currentItem
        })
        .filter(item => item.url || item.children?.length)
    },

    setActiveItemFromRoute (routeOrPath: RouteLocationNormalizedLoadedGeneric | string) {
      if (!routeOrPath) {
        this.activeItem = null
        return this.activeItem
      }

      const path = typeof routeOrPath === 'string' ? routeOrPath : routeOrPath.path
      let activeItem: null | IMenuItem = null
      let difference: null | number = null

      const findActiveItem = (items: IMenuItem[]) => {
        items.forEach(item => {
          item.active = false

          if (item.url !== '/' && path.includes(item.url)) {
            const _difference = path.replace(item.url, '').length

            if (difference == null || _difference <= difference) {
              activeItem = item
              difference = _difference
            }
          }

          if (item.children?.length) {
            findActiveItem(item.children)
          }
        })
      }

      findActiveItem(this.getItems)

      if (!activeItem) {
        this.activeItem = null
        return null
      }

      const matchedItem = activeItem as IMenuItem
      matchedItem.active = true
      this.activeItem = matchedItem
    },

    resetActiveItem () {
      this.activeItem = null
    }
  },
})
